var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('nav-bar',{ref:"navBar",attrs:{"products_cart":_vm.products_cart,"len_users":_vm.users.length}}),_vm._v(" "),_c('div',{staticClass:"main-container"},[_c('router-view',{key:_vm.$route.path,attrs:{"users":_vm.users,"products_cart":_vm.products_cart}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b5e7cf8c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = q8Yf
// module chunks = 0